import React, { useEffect, useState } from 'react';
import { Text, Button, VStack } from '@chakra-ui/react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { careerApi, applicantToken } from './careerApi';
import { AuthShell } from './Signup';

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [state, setState] = useState('working');
  const [error, setError] = useState('');

  useEffect(() => {
    const token = params.get('token');
    if (!token) { setState('failed'); setError('No token in link'); return; }
    (async () => {
      try {
        const res = await careerApi.verifyEmail(token);
        if (res?.token) applicantToken.set(res.token);
        setState('ok');
      } catch (e) {
        setError(e.message); setState('failed');
      }
    })();
  }, [params]);

  if (state === 'working') return <AuthShell title="Verifying…"><Text color="#718096" textAlign="center">Please wait.</Text></AuthShell>;
  if (state === 'failed') return (
    <AuthShell title="Verification failed">
      <Text color="#E53E3E" fontSize="13px" textAlign="center" mb="12px">{error}</Text>
      <Button as={Link} to="/signup" w="full">Sign up again</Button>
    </AuthShell>
  );
  return (
    <AuthShell title="Email verified 🎉">
      <VStack spacing="12px">
        <Text color="#4A5568" textAlign="center">You're all set. Start exploring open positions.</Text>
        <Button as={Link} to="/" bg="#3730A3" color="white" _hover={{ bg: '#312E81' }} w="full">Browse jobs</Button>
      </VStack>
    </AuthShell>
  );
}
